// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"customize-bundle-for-dpu_productcontent___J5gb"};